<template>
  <div class="sql-setting-popup">
    <div class="goback-small c-pointer l-align">
      <i class="fal fa-arrow-left" @click="onBackBtnClick"></i> SQL {{settingType}}
    </div>
    <el-form :model="formData" :rules="rules" label-width="120px" ref="form" label-position="top">
      <el-row>
        <el-col :span="12">
          <el-form-item label="SQL 명" prop="queryId">
            <el-input v-model="formData.queryId" placeholder="SQL명을 입력해 주십시오"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11" class="dbid-item">
          <el-form-item label="DB 명" prop="dbId">
            <el-select v-model="formData.dbId" placeholder="DB를 선택해 주십시오">
              <el-option v-for="item in dbInfo" :key="item.dbId" :label="item.dbId" :value="item.dbId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="결과 형태" prop="resultvalueType">
            <el-select v-model="formData.resultvalueType" placeholder="결과 타입을 선택해 주십시오">
              <el-option v-for="item in resultvalueTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <p class="label">SQL 문
          <el-popover popper-class="sql-help" placement="right" width="500" trigger="click" title="SQL 작성 도움말" :visible-arrow="false">
            <el-tabs class="tab-button" v-model="activeTab">
              <el-tab-pane label="공통" name="common">
                <div style="height: 400px">
                  <el-scrollbar class="bar-visible">
                    1. 별칭작성시 다음과 같은 항목을 준수하여 작성한다.
                    <li>연결할 장비의 이름에 대한 별칭은 label로 통일한다.</li>
                    <li>연결할 장비의 성능값에 대한 별칭은 value로 통일한다.</li>
                    <li>연결할 장비의 날짜값에 대한 별칭은 checkDatetime으로 통일한다.</li>
                    <li>연결할 장비의 성능값 단위에 대한 별칭은 unit으로 통일한다.(없다면 생략 가능)</li>
                    <br/>
                    2. 쿼리문 마지막에 세미콜론을 붙이지 않는다.
                    <br/><br />
                    3. 결과 Type
                    <li>문자열 : 단일 결과값이고 형식이 문자열인 경우</li>
                    <li>숫자 : 단일 결과값이고 형식이 숫자일 경우</li>
                    <li>리스트 : 목록 결과값일 경우</li>
                    <!-- <li>UNION : 다수의 쿼리 결과값을 UNION할 경우</li> -->
                    <!-- <li>JOIN : 다수의 쿼리 결과값을 JOIN할 경우</li> -->
                  </el-scrollbar>
                </div>
              </el-tab-pane>
              <el-tab-pane label="동적테이블" name="dynamic">
                <div style="height: 400px">
                  <el-scrollbar class="bar-visible">
                    1.날짜에 따라 동적으로 변하는 테이블 이름을 설정한다.
                    <li>형식 : $DATE{패턴} 혹은 $DATE{패턴,INTERVAL 타입}</li>
                    <br />
                    2. [패턴] JAVA SimpleDateFormat 패턴형식을 따른다.
                    <li>y : Year</li>
                    <li>Y : Week year</li>
                    <li>M : Month in year</li>
                    <li>w : Week in year</li>
                    <li>W : Week in month</li>
                    <li>D : Day in year</li>
                    <li>d : Day in month</li>
                    <li>F : Day of week in month</li>
                    <li>E : Day name in Week</li>
                    <li>u : Day number of week</li>
                    <li>a : Am/pm marker</li>
                    <li>H : Hour in day (0-23)</li>
                    <li>k : Hour in day (1-24)</li>
                    <li>K : Hour in am/pm (0-11)</li>
                    <li>h : Hour in am/pm (1-12)</li>
                    <li>m : Minute in hour</li>
                    <li>s : Second in minute</li>
                    <li>S : Millisecond</li>
                    <li>z : Time zone</li>
                    <li>Z : Time zone</li>
                    <li>X : Time zone</li>
                    <br />
                    3.INTERVAL
                    <li>±숫자</li>
                    <br />
                    4.Type
                    <li>YEAR : 년</li>
                    <li>MONTH :월</li>
                    <li>DATE : 일</li>
                    <li>WEEK_OF_YEAR :년도의 몇째 주</li>
                    <li>WEEK_OF_MONTH :월의 몇째 주</li>
                    <li>DAY_OF_YEAR : 년도의 날짜</li>
                    <li>DAY_OF_MONTH : 월의 날짜</li>
                    <li>DAY_OF_WEEK : 요일(일=1, 토=7)</li>
                    <li>HOUR : 시간(12시간)</li>
                    <li>HOUR_OF_DAY : 시간(12시간)</li>
                    <li>MINUTE : 분</li>
                    <li>SECOND : 초</li>
                    <br />
                    5. 예제 : 현재 2016-05-12 13:22:19 라고 가정한다.
                    <li>$DATE{yyyyMMdd} => 20160512</li>
                    <li>$DATE{yyyy-MM-dd HH:mm:ss} => 2016-05-12 13:22:19</li>
                    <li>$DATE{yyyyMMdd,-2 DATE} => 20160510</li>
                    <li>$DATE{yyyy-MM-dd HH:mm:ss,+3 HOUR} => 2016-05-12 16:22:19</li>
                    <li>SELECT * FROM DAY_$DATE{yyMMdd} => SELECT * FROM DAY_160512</li>
                  </el-scrollbar>
                </div>
              </el-tab-pane>
              <!-- <el-tab-pane label="결과 Type(UNION)" name="union">
                <div style="height: 400px">
                  <el-scrollbar class="bar-visible">
                    1. 각각 다른 DB의 쿼리 결과목록을 하나로 합쳐서 표현한다.<br /><br />
                    2. 각각 쿼리 결과의 컬럼 개수 및 컬럼명은 동일해야 한다.<br /><br />
                    3. N개의 쿼리 결과를 합칠 수 있다.<br /><br />
                    4. 예제<br />
                    (<br />
                    SELECT RESULTVALUE_STRING <br />
                    FROM DASHBOARD_QUERY_INFO <br />
                    WHERE QUERY_ID = "쿼리1 ID"<br />
                    )<br />
                    UNION ALL<br />
                    (<br />
                    SELECT RESULTVALUE_STRING <br />
                    FROM DASHBOARD_QUERY_INFO <br />
                    WHERE QUERY_ID = "쿼리2 ID"<br />
                    )<br />
                    UNION ALL<br />
                    (<br />
                    SELECT RESULTVALUE_STRING <br />
                    FROM DASHBOARD_QUERY_INFO <br />
                    WHERE QUERY_ID = "쿼리3 ID"<br />
                    )
                    ...<br />
                  </el-scrollbar>
                </div>
              </el-tab-pane> -->
              <!-- <el-tab-pane label="결과 Type(JOIN)" name="join">
                <div style="height: 400px">
                  <el-scrollbar class="bar-visible">
                    1. 각각 다른 DB의 쿼리 결과를 JOIN 하여 표현한다.<br /><br />
                    2. 각각 쿼리 결과는 대상(label), 값(value) 컬럼을 가져야한다.<br /><br />
                    3. JOIN의 기준이 되는 컬럼은 대상(label) 컬럼이다.<br /><br />
                    4. JOIN이 되면 값(value) 컬럼 이름은 value1, value2, value3 형식으로 부여가 된다.<br /><br />
                    5. N개의 쿼리 결과를 JOIN할 수 있다.<br /><br />
                    6. 예제<br />
                    (<br />
                    SELECT RESULTVALUE_STRING <br />
                    FROM DASHBOARD_QUERY_INFO <br />
                    WHERE QUERY_ID = "쿼리1 ID"<br />
                    )<br />
                    UNION ALL<br />
                    (<br />
                    SELECT RESULTVALUE_STRING <br />
                    FROM DASHBOARD_QUERY_INFO <br />
                    WHERE QUERY_ID = "쿼리2 ID"<br />
                    )<br />
                    UNION ALL<br />
                    (<br />
                    SELECT RESULTVALUE_STRING <br />
                    FROM DASHBOARD_QUERY_INFO <br />
                    WHERE QUERY_ID = "쿼리3 ID"<br />
                    )
                    ...<br />
                  </el-scrollbar>
                </div>
              </el-tab-pane> -->
            </el-tabs>
            <span slot="reference" style="margin-left: 10px;"><i class="fas fa-info-circle c-pointer"></i></span>
          </el-popover>
        </p>
        <el-input type="textarea" size="medium" resize="none" :autosize="sqlAreaSize" v-model="formData.queryString" :placeholder="placeholder"></el-input>
        <!-- <el-form-item label="SQL 문" prop="queryString">
        </el-form-item> -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
import SqlAPI from '@/api/dashboard/sql';

export default {
  name: 'WSqlInfoSettingForm',
  props: {
    settingType: {
      type: String,
      default: '추가',
    },
  },
  data() {
    return {
      sqlAreaSize: {
        minRows: 24,
        maxRows: 24,
      },
      formData: {
        queryId: null,
        dbId: null,
        resultvalueType: null,
        resultvalueString: null,
      },
      selectDbInfo: null,
      dbInfo: null,
      resultvalueTypeList: [
        {
          label: '문자열',
          value: 'STRING',
        },
        {
          label: '숫자',
          value: 'DOUBLE',
        },
        {
          label: '리스트',
          value: 'LIST',
        },
        // {
        //   label: 'UNION',
        //   value: 'UNION',
        // },
        // {
        //   label: 'JOIN',
        //   value: 'JOIN',
        // },
      ],
      rules: {
        queryId: [
          {
            required: true,
            message: 'SQL명을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
        resultvalueType: [
          {
            required: true,
            message: '결과형태를 선택해주십시오.',
            trigger: 'blur',
          },
        ],
        queryString: [
          {
            required: true,
            message: 'SQL문을 입력해주십시오.',
            trigger: 'blur',
          },
        ],
      },
      activeTab: 'common',
    };
  },
  computed: {
    placeholder() {
      let str = '';

      switch (this.formData.resultvalueType) {
        case 'STRING':
          str = `
SELECT
  값 AS value
FROM
  ...
          `;
          break;
        case 'DOUBLE':
          str = `
SELECT
  값 AS value
FROM
  ...
          `;
          break;
        case 'LIST':
          str = `
SELECT
  값1 AS value1,
  라벨1 AS label1,
  값2 AS value2,
  라벨2 AS label2,
  날짜 AS checkDatetime,
  단위 AS unit,
FROM
  ...
          `;
          break;
        default:
      }

      return str.replace(/^\n/, '');
    },
  },
  created() {
    SqlAPI.getDbInfo().then((response) => {
      this.dbInfo = response.data.data;
    });
  },
  methods: {
    addInfo() {
      SqlAPI.addQueryInfo(this.formData).then((response) => {
        const result = response.data;
        if (result.success) {
          this.$message({
            type: 'success',
            message: 'DB 정보를 추가하였습니다.',
          });
          this.$emit('loadData');
          this.onBackBtnClick();
        }
      });
    },
    updateInfo() {
      SqlAPI.updateQueryInfo(this.formData).then((response) => {
        const result = response.data;
        if (result.success) {
          this.$message({
            type: 'success',
            message: 'SQL 정보를 수정하였습니다.',
          });
          this.$emit('loadData');
          this.onBackBtnClick();
        }
      });
    },
    setUpdateData(data) {
      this.formData = data;
    },
    onBackBtnClick() {
      this.$emit('change-current-view-type', 'mainView');
    },
    getFormData() {
      return {
        name: 'SQL 명',
        data: { queryId: this.formData.queryId },
      };
    },
  },
};
</script>
<style lang="scss">
.sql-setting-popup {
  height: 100%;

  .el-select {
    width: 100%;
    /* margin-left: 10px; */
  }

  .dbid-item {
    margin-left: 10px;
    .el-select {
      width: calc(100% + 18px);
      /* margin-left: 10px; */
    }
  }
  .label {
    font-size: 13px !important;
    color: #686868 !important;
    margin: 0px 0px 7px 0px !important;
    font-weight: normal;
  }
}
.sql-help {
  font-family: NunitoSans,Malgun Gothic,sans-serif!important;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/form/SqlInfoSettingForm.vue